<template>
    <PeaMenuu></PeaMenuu>
    <v-main>
        <v-container fluid>
            <v-row>
                <v-col>
                    <slot name="pais"></slot>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <slot></slot>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import PeaMenuu from "./PeaMenuu.vue"
import { AuthTeenus } from '@/core/auth-teenus';

const _authTeenus = new AuthTeenus();

export default defineComponent({
    name: 'KRHPPaigutus',
    data() {
        return {
            authService: _authTeenus,
            show: false,
        }
    },
    props: {
        portaaliPealkiri: String,
        lehePealkiri: String,
        lehePaiseTekst: {
            type: String,
        },
        lehePaiseTekstLuhendatud: {
            type: String,
        }
    },
    components: { PeaMenuu }
});
</script>

<style>
.v-table{
font-size: inherit !important;
}
</style>